/**
 * @generated SignedSource<<81bd510d0e4418d97e4240052f5f11c1>>
 * @relayHash e462b0f3a651e4487b3f2780fb8177ab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0a2bb4563c411c842454af625b6d3c00b45fd05424ec07b2263caf7633aa745a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0a2bb4563c411c842454af625b6d3c00b45fd05424ec07b2263caf7633aa745a",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
